<script lang="ts" setup>
  import { BaseButton, Text } from '@bt/design-system'
  import { cva } from 'class-variance-authority'
  import renderRichText from '@/utils/renderSbRichText'
  import type { ITermsAndConditions } from '@/components/General/termsAndConditions/types'

  const props = withDefaults(defineProps<ITermsAndConditions>(), {
    fullScreen: true
  })

  const emit = defineEmits(['accept', 'decline'])

  const textBase = computed(() =>
    cva('mb-8', {
      variants: {
        full: {
          true: '',
          false: 'text-center'
        }
      }
    })({
      full: props.fullScreen
    })
  )

  const buttonBase = computed(() =>
    cva('flex', {
      variants: {
        full: {
          true: 'justify-between gap-2 md:gap-4',
          false: 'justify-center'
        }
      }
    })({
      full: props.fullScreen
    })
  )
</script>

<template>
  <div class="px-4 pb-10 md:!pl-8 md:!pr-5 md:pb-12">
    <Text
      :class="textBase"
      type="body1"
      :text="renderRichText(data.content)"
    />
    <div :class="buttonBase">
      <BaseButton
        v-if="data.acceptText"
        color="ghost"
        block-type="full"
        :title="data.acceptText"
        :class="data.declineText ? '!flex-shrink !px-2 md:!w-1/2' : 'max-w-80 lg:!w-28'"
        @click="emit('accept')"
      />

      <BaseButton
        v-if="data.declineText"
        color="ghost"
        block-type="full"
        :title="data.declineText"
        class="!flex-shrink !px-2 md:!w-1/2"
        @click="emit('decline')"
      />
    </div>
  </div>
</template>
